module.exports = __webpack_public_path__ + "img/member-img.png";